var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-1 0 24 24",
    id: "meteor-icon-kit__solid-spinner-star",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 2C9.5 0 12.5 0 12.5 2V7C12.5 9 9.5 9 9.5 7V2zM9.5 17C9.5 15 12.5 15 12.5 17V22C12.5 24 9.5 24 9.5 22V17zM18.9103 5.70096C20.6423 4.70096 22.1423 7.29904 20.4103 8.29904L16.0801 10.799C14.3481 11.799 12.8481 9.20096 14.5801 8.20096L18.9103 5.70096zM5.91988 13.201C7.65194 12.201 9.1519 14.799 7.41988 15.799L3.08976 18.299C1.35771 19.299 -0.142293 16.701 1.58976 15.701L5.91988 13.201zM1.58976 8.29904C-0.142293 7.29904 1.35771 4.70096 3.08976 5.70096L7.41988 8.20096C9.1519 9.20096 7.65194 11.799 5.91988 10.799L1.58976 8.29904zM14.5801 15.799C12.8481 14.799 14.3481 12.201 16.0801 13.201L20.4103 15.701C22.1423 16.701 20.6423 19.299 18.9103 18.299L14.5801 15.799z",
    fill: "#00acc1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerLogo);
export default __webpack_public_path__ + "static/media/spinner-logo.2575750190ae21c704a01dbfdd6db7a6.svg";
export { ForwardRef as ReactComponent };